import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.063 3.002 7 3l-.15.005A2 2 0 0 0 5 5v22l.005.15A2 2 0 0 0 7 29h18l.15-.006A2 2 0 0 0 27 27l.001-16-.007-.117a1 1 0 0 0-.294-.599l-6.992-6.991-.083-.073-.032-.025-.08-.054-.073-.04-.116-.047-.12-.033-.047-.009zM7 5h11v6l.007.117A1 1 0 0 0 19 12h6v15H7zm6.613 15.21.094.083 1.387 1.386L16.4 20.7a1 1 0 0 1 1.09-.072l.11.072 1.505 1.129 1.448-.723a1 1 0 0 1 1.283.345l.058.102a1 1 0 0 1-.345 1.283l-.102.058-2 1a1 1 0 0 1-.942-.025L18.4 23.8 17 22.75l-1.4 1.05a1 1 0 0 1-1.215-.011l-.092-.082L13 22.415l-1.293 1.292a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1-.083-1.32l.083-.094 2-2a1 1 0 0 1 1.32-.083M22 16a1 1 0 0 0-1-1H11l-.117.007A1 1 0 0 0 11 17h10l.117-.007A1 1 0 0 0 22 16m-7-5a1 1 0 0 1 .117 1.993L15 13h-4a1 1 0 0 1-.117-1.993L11 11zm5-1V6.414L23.585 10z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconLeadProposals = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconLeadProposals);
export default Memo;
